import { Account } from '@features/accounts/types';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import { Button, Flex, Text } from '@radix-ui/themes';

import styles from './AccountCard.module.css';

interface AccountCardProps {
    account: Account;
    onSelected: (account: Account) => void;
}

export const AccountCard = ({ account, onSelected }: AccountCardProps) => {
    const { name } = account;

    return (
        <Button
            className={styles.container}
            variant={'outline'}
            onClick={() => onSelected(account)}
            asChild
        >
            <Flex align={'center'} justify={'between'}>
                <Text color='gray' highContrast className={styles.name}>
                    {name}
                </Text>
                <ChevronRightIcon className={styles.icon} />
            </Flex>
        </Button>
    );
};
